{
	"login": {
		"title": "Sign in to StudyHub",
		"lead": "One account for the whole ecosystem.",
		"signIn": "Sign in",
		"legalDisclaimer": "By clicking «Sign in» you agree to the Terms of Service and Privacy Policy.",
		"devOr": "or",
		"emailLabel": "Email",
		"passwordLabel": "Password",
		"emailSubmit": "Sign in",
		"emailSignedIn": "Welcome back!",
		"devHint": "Dev mode: email and password",
		"devQuickPick": "Quick pick",
		"forgotPassword": "Forgot password?",
		"togglePassword": "Show/hide password",
		"demoLoadingTitle": "Redirecting to Exchange…",
		"demoLoadingDesc": "Hold on, opening the secure sign-in page.",
		"errorTitle": "Sign-in failed",
		"errorBody": "Exchange returned an error: {code}",
		"errorRetry": "Try again",
		"errorHelp": "Contact support",
		"offlineBanner": "Offline — sign-in is unavailable. Check your connection.",
		"alreadyAuthRedirect": "Redirecting to StudyHub…",
		"selectDevAccount": "Selected {email}",
		"previewBadge": "Platform preview",
		"heroTitle": "Upload a lecture — get notes, flashcards and a quiz in a minute.",
		"heroLead": "StudyHub turns PDFs, videos, photos and lecture recordings into a ready study pack: notes, flashcards, a quiz and an AI tutor that knows your material.",
		"mockMaterialTitle": "Lecture 12 — Cellular respiration",
		"mockMaterialMeta": "91 min · ready 47 sec ago",
		"mockBadgeNotes": "Notes · 3 levels",
		"mockBadgeCards": "24 cards",
		"mockBadgeQuiz": "Quiz · 15 questions",
		"mockBadgePodcast": "Audio recap · 8:42",
		"kpiSpeed": "~45 sec",
		"kpiSpeedDesc": "from upload to ready material",
		"kpiFree": "50 / week",
		"kpiFreeDesc": "AI generations on Free",
		"kpiLang": "AI",
		"kpiLangDesc": "notes, cards, quizzes",
		"helpLink": "Help",
		"emailToggleLabel": "Sign in with email and password",
		"themeToggle": "Toggle theme",
		"mockMaterialReady": "Ready",
		"footerCopyright": "© 2026 StudyHub",
		"footerPrivacy": "Privacy Policy",
		"footerTerms": "Terms of Service",
		"kpiOffline": "Offline",
		"kpiOfflineDesc": "your materials without a connection"
	},
	"callback": {
		"finishing": "Finishing sign-in…"
	},
	"sessionExpired": {
		"title": "Session expired",
		"body": "To continue, sign in to your account again.",
		"localChangesSafe": "Your offline changes are saved on this device and will sync after you sign in.",
		"cta": "Sign in again"
	},
	"signup": {
		"title": "Create account",
		"submit": "Create account",
		"haveAccount": "Already have an account?",
		"loginLink": "Sign in"
	},
	"logout": {
		"action": "Sign out",
		"confirmTitle": "Sign out?",
		"confirmDescription": "Local unsynced data may be lost.",
		"confirmAction": "Sign out"
	},
	"consent": {
		"title": "Consent",
		"privacy": "I accept the Privacy Policy",
		"terms": "I accept the Terms of Service",
		"aiDisclaimer": "I understand that StudyHub uses AI to generate notes, flashcards and quizzes. AI may be wrong — important facts are worth double-checking against the source.",
		"submit": "Accept and continue",
		"required": "All items must be accepted to continue"
	},
	"accountDeletion": {
		"title": "Delete account",
		"description": "Your account will be scheduled for deletion. After 30 days, all data will be permanently erased. Until then, you can cancel deletion and come back.",
		"confirm": "Delete account",
		"cancel": "Cancel deletion",
		"gracePeriodNotice": "Deletion scheduled for {date}"
	},
	"errors": {
		"invalidCredentials": "Invalid email or password",
		"accountBanned": "Account is banned",
		"sessionExpired": "Session expired — sign in again"
	},
	"impersonation": {
		"processing": "Signing in as the user…",
		"errorTitle": "Couldn't sign in as the user",
		"errorHelp": "The session may have expired or the link was already used. Go back to admin and try again.",
		"backToAdmin": "Back to admin",
		"banner": "You are signed in as {email} (admin mode).",
		"bannerNoEmail": "You are signed in as another user (admin mode).",
		"exit": "Exit"
	},
	"sessionRevoked": {
		"body": "Your session was ended. Please sign in again.",
		"passwordChanged": "Your password changed — sign in again."
	}
}
